"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaybookMarketplaceWebTypes = exports.PlaybookFastlaneTypes = exports.PlaybookChatTypes = exports.PlaybookLandingPageTypes = exports.PlaybookEmailTypes = exports.PlaybookMigratedTypes = exports.PlaybookEditorTypes = void 0;
var PlaybookEditorTypes;

(function (PlaybookEditorTypes) {
  PlaybookEditorTypes["EMPTY_LEADBOT"] = "EMPTY_LEADBOT";
  PlaybookEditorTypes["BOOK_MORE_MEETINGS"] = "BOOK_MORE_MEETINGS";
  PlaybookEditorTypes["MORE_QUALIFIED_CONVERSATIONS"] = "MORE_QUALIFIED_CONVERSATIONS";
  PlaybookEditorTypes["LANDING_PAGE_LEADBOT"] = "LANDING_PAGE_LEADBOT";
  PlaybookEditorTypes["VSB_DEFAULT_PLAYBOOK"] = "VSB_DEFAULT_PLAYBOOK";
  PlaybookEditorTypes["CONVERSATION_STARTER_BOT"] = "CONVERSATION_STARTER_BOT";
  PlaybookEditorTypes["RETARGETING_BOT"] = "RETARGETING_BOT";
  PlaybookEditorTypes["PRICING_PAGE_BOT"] = "PRICING_PAGE_BOT";
  PlaybookEditorTypes["SECOND_NET_BOT"] = "SECOND_NET_BOT";
  PlaybookEditorTypes["ABM_HOMEPAGE_BOT"] = "ABM_HOMEPAGE_BOT";
  PlaybookEditorTypes["PAID_TRAFFIC_BOT"] = "PAID_TRAFFIC_BOT";
  PlaybookEditorTypes["FORM_REPLACER_CLP"] = "FORM_REPLACER_CLP";
  PlaybookEditorTypes["CONVO_CONTENT_CLP"] = "CONVO_CONTENT_CLP";
  PlaybookEditorTypes["ENTERPRISE_BOT"] = "ENTERPRISE_BOT";
  PlaybookEditorTypes["AI_TOPICS"] = "AI_TOPICS";
  PlaybookEditorTypes["ENGAGE_ALL_BOT"] = "ENGAGE_ALL_BOT";
  PlaybookEditorTypes["SKIP_THE_FORM_BOT"] = "SKIP_THE_FORM_BOT";
  PlaybookEditorTypes["VISITOR_RETARGETING_BOT"] = "VISITOR_RETARGETING_BOT";
  PlaybookEditorTypes["BLOG_BOT"] = "BLOG_BOT";
  PlaybookEditorTypes["PAID_AD_CONVERTER_BOT"] = "PAID_AD_CONVERTER_BOT";
  PlaybookEditorTypes["TARGET_ACCOUNTS_BOT"] = "TARGET_ACCOUNTS_BOT";
  PlaybookEditorTypes["MEETING_BOOKING_BOT"] = "MEETING_BOOKING_BOT";
})(PlaybookEditorTypes = exports.PlaybookEditorTypes || (exports.PlaybookEditorTypes = {}));

var PlaybookMigratedTypes;

(function (PlaybookMigratedTypes) {
  PlaybookMigratedTypes["PROMOTION_FULL_SCREEN_TAKEOVER"] = "PROMOTION_FULL_SCREEN_TAKEOVER";
  PlaybookMigratedTypes["EMPTY_WELCOME_MESSAGE"] = "EMPTY_WELCOME_MESSAGE";
  PlaybookMigratedTypes["DRIVE_TRAFFIC_TARGETED_MESSAGE"] = "DRIVE_TRAFFIC_TARGETED_MESSAGE";
  PlaybookMigratedTypes["TALK_TO_YOUR_OUTBOUND_PROSPECTS"] = "TALK_TO_YOUR_OUTBOUND_PROSPECTS";
  PlaybookMigratedTypes["ABM"] = "ABM";
  PlaybookMigratedTypes["EMPTY_SLIDER"] = "EMPTY_SLIDER";
  PlaybookMigratedTypes["BUILD_A_SUBSCRIBER_LIST"] = "BUILD_A_SUBSCRIBER_LIST";
})(PlaybookMigratedTypes = exports.PlaybookMigratedTypes || (exports.PlaybookMigratedTypes = {}));

var PlaybookEmailTypes;

(function (PlaybookEmailTypes) {
  PlaybookEmailTypes["SEND_AN_AUTOMATED_EMAIL"] = "SEND_AN_AUTOMATED_EMAIL";
  PlaybookEmailTypes["SEND_A_ONETIME_EMAIL"] = "SEND_A_ONETIME_EMAIL";
  PlaybookEmailTypes["SEND_A_ONETIME_OUTBOUND_EMAIL"] = "SEND_A_ONETIME_OUTBOUND_EMAIL";
  PlaybookEmailTypes["OUTBOUND_SEQUENCE"] = "OUTBOUND_SEQUENCE";
  PlaybookEmailTypes["MARKETING_SEQUENCE"] = "MARKETING_SEQUENCE";
  PlaybookEmailTypes["MARKETING_ONE_TIME_SEQUENCE"] = "MARKETING_ONE_TIME_SEQUENCE";
  PlaybookEmailTypes["BLOG_NURTURE"] = "BLOG_NURTURE";
  PlaybookEmailTypes["NEW_BLOG_CONTENT"] = "NEW_BLOG_CONTENT";
  PlaybookEmailTypes["NEWSLETTER"] = "NEWSLETTER";
  PlaybookEmailTypes["PRODUCT_ANNOUNCEMENT"] = "PRODUCT_ANNOUNCEMENT";
  PlaybookEmailTypes["SIGNATURE"] = "SIGNATURE";
})(PlaybookEmailTypes = exports.PlaybookEmailTypes || (exports.PlaybookEmailTypes = {}));

var PlaybookLandingPageTypes;

(function (PlaybookLandingPageTypes) {
  PlaybookLandingPageTypes["LANDING_PAGE_LEADBOT"] = "LANDING_PAGE_LEADBOT";
  PlaybookLandingPageTypes["FORM_REPLACER_CLP"] = "FORM_REPLACER_CLP";
  PlaybookLandingPageTypes["CONVO_CONTENT_CLP"] = "CONVO_CONTENT_CLP";
})(PlaybookLandingPageTypes = exports.PlaybookLandingPageTypes || (exports.PlaybookLandingPageTypes = {}));

var PlaybookChatTypes;

(function (PlaybookChatTypes) {
  PlaybookChatTypes["BOOK_MORE_MEETINGS"] = "BOOK_MORE_MEETINGS";
  PlaybookChatTypes["MORE_QUALIFIED_CONVERSATIONS"] = "MORE_QUALIFIED_CONVERSATIONS";
  PlaybookChatTypes["MORE_SALES_CONVERSATIONS"] = "MORE_SALES_CONVERSATIONS";
  PlaybookChatTypes["DRIVE_TRAFFIC_TARGETED_MESSAGE"] = "DRIVE_TRAFFIC_TARGETED_MESSAGE";
  PlaybookChatTypes["PROMOTION_FULL_SCREEN_TAKEOVER"] = "PROMOTION_FULL_SCREEN_TAKEOVER";
  PlaybookChatTypes["TALK_TO_YOUR_OUTBOUND_PROSPECTS"] = "TALK_TO_YOUR_OUTBOUND_PROSPECTS";
  PlaybookChatTypes["BUILD_A_SUBSCRIBER_LIST"] = "BUILD_A_SUBSCRIBER_LIST";
  PlaybookChatTypes["EMPTY_LEADBOT"] = "EMPTY_LEADBOT";
  PlaybookChatTypes["EMPTY_SLIDER"] = "EMPTY_SLIDER";
  PlaybookChatTypes["EMPTY_TAKEOVER"] = "EMPTY_TAKEOVER";
  PlaybookChatTypes["EMPTY_WELCOME_MESSAGE"] = "EMPTY_WELCOME_MESSAGE";
  PlaybookChatTypes["NPS_BOT"] = "NPS_BOT";
  PlaybookChatTypes["ABM"] = "ABM";
  PlaybookChatTypes["LANDING_PAGE_LEADBOT"] = "LANDING_PAGE_LEADBOT";
  PlaybookChatTypes["VSB_DEFAULT_PLAYBOOK"] = "VSB_DEFAULT_PLAYBOOK";
  PlaybookChatTypes["CONVERSATION_STARTER_BOT"] = "CONVERSATION_STARTER_BOT";
  PlaybookChatTypes["RETARGETING_BOT"] = "RETARGETING_BOT";
  PlaybookChatTypes["PRICING_PAGE_BOT"] = "PRICING_PAGE_BOT";
  PlaybookChatTypes["SECOND_NET_BOT"] = "SECOND_NET_BOT";
  PlaybookChatTypes["ABM_HOMEPAGE_BOT"] = "ABM_HOMEPAGE_BOT";
  PlaybookChatTypes["PAID_TRAFFIC_BOT"] = "PAID_TRAFFIC_BOT";
  PlaybookChatTypes["FORM_REPLACER_CLP"] = "FORM_REPLACER_CLP";
  PlaybookChatTypes["CONVO_CONTENT_CLP"] = "CONVO_CONTENT_CLP";
  PlaybookChatTypes["ENTERPRISE_BOT"] = "ENTERPRISE_BOT";
  PlaybookChatTypes["AI_TOPICS"] = "AI_TOPICS";
  PlaybookChatTypes["ENGAGE_ALL_BOT"] = "ENGAGE_ALL_BOT";
  PlaybookChatTypes["SKIP_THE_FORM_BOT"] = "SKIP_THE_FORM_BOT";
  PlaybookChatTypes["VISITOR_RETARGETING_BOT"] = "VISITOR_RETARGETING_BOT";
  PlaybookChatTypes["BLOG_BOT"] = "BLOG_BOT";
  PlaybookChatTypes["PAID_AD_CONVERTER_BOT"] = "PAID_AD_CONVERTER_BOT";
  PlaybookChatTypes["TARGET_ACCOUNTS_BOT"] = "TARGET_ACCOUNTS_BOT";
})(PlaybookChatTypes = exports.PlaybookChatTypes || (exports.PlaybookChatTypes = {}));

var PlaybookFastlaneTypes;

(function (PlaybookFastlaneTypes) {
  PlaybookFastlaneTypes["FORM_SUBMISSION_FAST_LANE"] = "FORM_SUBMISSION_FAST_LANE";
})(PlaybookFastlaneTypes = exports.PlaybookFastlaneTypes || (exports.PlaybookFastlaneTypes = {}));

var PlaybookMarketplaceWebTypes;

(function (PlaybookMarketplaceWebTypes) {
  PlaybookMarketplaceWebTypes["MARKETING_SEQUENCE"] = "MARKETING_SEQUENCE";
  PlaybookMarketplaceWebTypes["MARKETING_ONE_TIME_SEQUENCE"] = "MARKETING_ONE_TIME_SEQUENCE";
  PlaybookMarketplaceWebTypes["BLOG_NURTURE"] = "BLOG_NURTURE";
  PlaybookMarketplaceWebTypes["NEW_BLOG_CONTENT"] = "NEW_BLOG_CONTENT";
  PlaybookMarketplaceWebTypes["NEWSLETTER"] = "NEWSLETTER";
  PlaybookMarketplaceWebTypes["PRODUCT_ANNOUNCEMENT"] = "PRODUCT_ANNOUNCEMENT";
  PlaybookMarketplaceWebTypes["OUTBOUND_SEQUENCE"] = "OUTBOUND_SEQUENCE";
  PlaybookMarketplaceWebTypes["SIGNATURE"] = "SIGNATURE";
})(PlaybookMarketplaceWebTypes = exports.PlaybookMarketplaceWebTypes || (exports.PlaybookMarketplaceWebTypes = {}));